<script>
  import CodeSnippet from '../components/CodeSnippet.svelte';

  const textboxSnippet = `
    <label for="first-name" class="label">First name</label>
    <div id="help-first-name" class="help">
      We just need your first name.
    </div>
    <input
      type="text"
      name="firstName"
      id="first-name"
      aria-describedby="help-first-name error-first-name"
      aria-invalid="false"
      class="textbox mt-4 w-1/3" />
    <div
      type="error"
      id="error-first-name"
      aria-live="polite"
      class="error">
      Uh-oh!
    </div>
  `;

  const textareaSnippet = `
    <label for="description" class="label">Description</label>
    <div id="help-description" class="help">Describe yourself.</div>
    <textarea
      name="description"
      id="description"
      aria-describedby="help-description error-description"
      aria-invalid="false"
      class="textbox mt-4 w-1/3"></textarea>
    <div
      type="error"
      id="error-description"
      aria-live="polite"
      class="error">
      Uh-oh!
    </div>
  `;

  const selectSnippet = `
    <label for="state" class="label">State</label>
    <div id="help-state" class="help">We just need your state.</div>
    <select
      name="state"
      id="state"
      aria-describedby="help-state error-state"
      aria-invalid="false"
      class="select mt-4 w-1/3">
      <option value="act">ACT</option>
      <option value="nsw">NSW</option>
      <option value="nt">NT</option>
      <option value="qld">QLD</option>
      <option value="sa">SA</option>
      <option value="tas">TAS</option>
      <option value="vic">VIC</option>
      <option value="wa">WA</option>
    </select>
    <div type="error" id="error-state" aria-live="polite" class="error">
      Uh-oh!
    </div>
  `;

  const checkboxSnippet = `
    <legend for="pets" class="legend">Do you have a pet?</legend>
    <div id="help-pets" class="help">Select which pets you have.</div>
    <input
      name="dog"
      id="dog"
      type="checkbox"
      aria-describedby="help-dog error-dog"
      aria-invalid="false"
      class="checkbox" />
    <label for="dog" class="checkbox-label mt-4">Dog</label>
    <input
      name="cat"
      id="cat"
      type="checkbox"
      aria-describedby="help-cat error-cat"
      aria-invalid="false"
      class="checkbox" />
    <label for="cat" class="checkbox-label mt-4">Cat</label>
    <div type="error" id="error-pets" aria-live="polite" class="error">
      Uh-oh!
    </div>
  `;

  const radioSnippet = `
    <legend for="radio-colour" class="legend">
      What is your favourite colour?
    </legend>
    <div id="help-radio-colour" class="help">
      Select your favourite colour.
    </div>
    <input
      name="radio-colour"
      id="radio-red"
      type="radio"
      aria-describedby="help-radio-red error-radio-red"
      aria-invalid="false"
      class="radio" />
    <label for="radio-red" class="radio-label mt-4">Red</label>
    <input
      name="radio-colour"
      id="radio-blue"
      type="radio"
      aria-describedby="help-radio-blue error-radio-blue"
      aria-invalid="false"
      class="radio" />
    <label for="radio-blue" class="radio-label mt-4">Blue</label>
    <div type="error" id="error-colour" aria-live="polite" class="error">
      Uh-oh!
    </div>
  `;
</script>

<template>
  <section id="form" class="page-section bg-white">
    <div class="container">
      <h2 class="heading heading-2 my-6">Forms</h2>
      <form class="form">
        <div class="space-y-4">
          <div>
            <h3 class="heading heading-3 mb-6">Textbox</h3>
            {@html textboxSnippet}
            <CodeSnippet id="textbox" snippet={textboxSnippet} />
          </div>
          <div>
            <h3 class="heading heading-3 mt-8 mb-6">Textarea</h3>
            {@html textareaSnippet}
            <CodeSnippet id="textarea" snippet={textareaSnippet} />
          </div>
          <div>
            <h3 class="heading heading-3 mt-8 mb-6">Select</h3>
            {@html selectSnippet}
            <CodeSnippet id="select" snippet={selectSnippet} />
          </div>
          <div>
            <h3 class="heading heading-3 mt-8 mb-6">Checkbox</h3>
            {@html checkboxSnippet}
            <CodeSnippet id="checkbox" snippet={checkboxSnippet} />
          </div>
          <div>
            <h3 class="heading heading-3 mt-8 mb-6">Radio</h3>
            {@html radioSnippet}
            <CodeSnippet id="radio" snippet={radioSnippet} />
          </div>
        </div>
      </form>
    </div>
  </section>
</template>
